export default __webpack_public_path__ + "static/media/img_06.668401cf.png";